import { FeatureFlagContext } from "./useFeatureFlags";
import { LoggingContext } from "./useLogging";
import { Box } from "../../../../../../mads";
import { useLocale } from "../../../../../../shared/I18n";
import { useLogger } from "../../../../../../shared/logging/logger";
import { useViewjobOneGraphModel } from "../../../../context/ViewJobDataContext";
import { useDsanrCookie } from "../../../../hooks/useDsanrCookie";
import FrontendLogger from "../logging/FrontendLogger";
import { defaultFeatureFlags, getFeatureFlags } from "../proctor/FeatureFlags";

import React, { useMemo } from "react";

export const JMUIContextProviders: React.FC<{
  providerId: string;
  children?: React.ReactNode;
}> = ({ children, providerId }) => {
  const logger = useLogger();
  const frontendLogger = useMemo(
    () => logger && new FrontendLogger(logger, providerId),
    [logger, providerId],
  );

  const { language, country } = useLocale();
  const viewjobOneGraphModel = useViewjobOneGraphModel();
  const dsanr = useDsanrCookie();

  const featureFlags = useMemo(() => {
    if (viewjobOneGraphModel) {
      const {
        shouldAlwaysShowProfileInsights,
        shouldShowTypicallyRequiredProfileInsights,
        shouldMergeMceDataProfileInsights,
        shouldUseMceAttributes,
        shouldHideAttributesWithoutRequirementStrength,
        shouldHideStrictnessForInferredAttributes,
        shouldLimitExpandedChipCount,
        shouldOnlyDisplayMustHaveRequirements,

        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        crowtaxoFrontendTstPayload,
        isApp,
      } = viewjobOneGraphModel.features;

      return getFeatureFlags({
        shouldAlwaysShowProfileInsights,
        shouldShowTypicallyRequiredProfileInsights,
        shouldMergeMceDataProfileInsights,
        shouldUseMceAttributes,
        shouldHideAttributesWithoutRequirementStrength,
        shouldHideStrictnessForInferredAttributes,
        shouldLimitExpandedChipCount,
        shouldOnlyDisplayMustHaveRequirements,
        country: country ?? "",
        language,
        isClientAppMobile: isApp,
        providerId,
        dsanr,

        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        crowtaxoFrontendTstPayload,
      });
    }

    return defaultFeatureFlags;
  }, [viewjobOneGraphModel, providerId, language, country, dsanr]);

  const accountKey = viewjobOneGraphModel?.accountKey;
  const mobtk = viewjobOneGraphModel?.mobvjtk;
  frontendLogger?.setAccountKey(accountKey);
  frontendLogger?.setClientTk(mobtk ?? "");

  return (
    <Box>
      <FeatureFlagContext.Provider value={featureFlags}>
        <LoggingContext.Provider value={{ logger: frontendLogger }}>
          {children}
        </LoggingContext.Provider>
      </FeatureFlagContext.Provider>
    </Box>
  );
};
